import styled from 'styled-components';

import { getFontStyle } from '~components/Text/helper';
import { HEADER_HEIGHT } from '~constant/layout';

export default function ErrorPage() {
  return (
    <Wrapper>
      <img src='https://image.wanted.co.kr/kreditjob/www/ico-error.png' alt='sad face' />
      <Text>
        예상하지 못한 에러가 발생했습니다.
        <br />
        잠시 후 다시 시도해주세요.
      </Text>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  text-align: center;
  padding: calc(180px + ${HEADER_HEIGHT}px) 0 180px;
  background-color: ${({ theme }) => theme.colors.gray200};
`;

const Text = styled.div`
  ${getFontStyle('bold150_B2')}
  padding: 10px 0 0;
  color: ${({ theme }) => theme.colors.gray700};
`;
